import * as defaultImport from "@splunk/visualizations/Markdown";
export * from "@splunk/visualizations/Markdown";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
